import { render, staticRenderFns } from "./SignatureQuestion.vue?vue&type=template&id=fd482662&scoped=true&"
import script from "./SignatureQuestion.vue?vue&type=script&lang=js&"
export * from "./SignatureQuestion.vue?vue&type=script&lang=js&"
import style0 from "./SignatureQuestion.vue?vue&type=style&index=0&id=fd482662&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd482662",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
